import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-18 bg-secondary-50">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-5">
          <i className="ri-heart-pulse-line text-2xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
          关注女性健康，从了解自己的身体开始
        </h2>
        <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-xl mx-auto leading-relaxed">
          我们致力于提供专业、易懂的女性生殖健康科普知识，帮助每一位女性科学认识自身，守护健康。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/examination"
            className="px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解检查指南
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50 text-foreground-700 border border-background-300 rounded-full font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}